/* tslint:disable */
/* eslint-disable */
/**
 * Happyforce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { LoginResponse } from '../models';
// @ts-ignore
import type { UploadUserImageRequest } from '../models';
// @ts-ignore
import type { UserAppActivationTokenDTO } from '../models';
// @ts-ignore
import type { UserComparisonFilterDTO } from '../models';
// @ts-ignore
import type { UserDTO } from '../models';
// @ts-ignore
import type { UserSelfProfileUpdateDTO } from '../models';
/**
 * UserProfileResourceApi - axios parameter creator
 * @export
 */
export const UserProfileResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {UserComparisonFilterDTO} userComparisonFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (userComparisonFilterDTO: UserComparisonFilterDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userComparisonFilterDTO' is not null or undefined
            assertParamExists('create', 'userComparisonFilterDTO', userComparisonFilterDTO)
            const localVarPath = `/api/v1/company/user/filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userComparisonFilterDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComparisonFilter: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteComparisonFilter', 'id', id)
            const localVarPath = `/api/v1/company/user/filters/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllComparisonFilters: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/company/user/filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProfile: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/company/user/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAppCode: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/company/user/appToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UserComparisonFilterDTO} userComparisonFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComparisonFilter: async (id: string, userComparisonFilterDTO: UserComparisonFilterDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateComparisonFilter', 'id', id)
            // verify required parameter 'userComparisonFilterDTO' is not null or undefined
            assertParamExists('updateComparisonFilter', 'userComparisonFilterDTO', userComparisonFilterDTO)
            const localVarPath = `/api/v1/company/user/filters/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userComparisonFilterDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserSelfProfileUpdateDTO} userSelfProfileUpdateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserProfile: async (userSelfProfileUpdateDTO: UserSelfProfileUpdateDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userSelfProfileUpdateDTO' is not null or undefined
            assertParamExists('updateUserProfile', 'userSelfProfileUpdateDTO', userSelfProfileUpdateDTO)
            const localVarPath = `/api/v1/company/user/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userSelfProfileUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UploadUserImageRequest} [uploadUserImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUserImage: async (uploadUserImageRequest?: UploadUserImageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/company/user/image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication companyAPISessionId required
            await setApiKeyToObject(localVarHeaderParameter, "SessionId", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadUserImageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserProfileResourceApi - functional programming interface
 * @export
 */
export const UserProfileResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserProfileResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {UserComparisonFilterDTO} userComparisonFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(userComparisonFilterDTO: UserComparisonFilterDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserComparisonFilterDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(userComparisonFilterDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfileResourceApi.create']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteComparisonFilter(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserComparisonFilterDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteComparisonFilter(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfileResourceApi.deleteComparisonFilter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllComparisonFilters(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserComparisonFilterDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllComparisonFilters(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfileResourceApi.getAllComparisonFilters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserProfile(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserProfile(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfileResourceApi.getUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveAppCode(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserAppActivationTokenDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrieveAppCode(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfileResourceApi.retrieveAppCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UserComparisonFilterDTO} userComparisonFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateComparisonFilter(id: string, userComparisonFilterDTO: UserComparisonFilterDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserComparisonFilterDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateComparisonFilter(id, userComparisonFilterDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfileResourceApi.updateComparisonFilter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UserSelfProfileUpdateDTO} userSelfProfileUpdateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserProfile(userSelfProfileUpdateDTO: UserSelfProfileUpdateDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserProfile(userSelfProfileUpdateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfileResourceApi.updateUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UploadUserImageRequest} [uploadUserImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadUserImage(uploadUserImageRequest?: UploadUserImageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadUserImage(uploadUserImageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfileResourceApi.uploadUserImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserProfileResourceApi - factory interface
 * @export
 */
export const UserProfileResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserProfileResourceApiFp(configuration)
    return {
        /**
         * 
         * @param {UserComparisonFilterDTO} userComparisonFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(userComparisonFilterDTO: UserComparisonFilterDTO, options?: RawAxiosRequestConfig): AxiosPromise<UserComparisonFilterDTO> {
            return localVarFp.create(userComparisonFilterDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComparisonFilter(id: string, options?: RawAxiosRequestConfig): AxiosPromise<UserComparisonFilterDTO> {
            return localVarFp.deleteComparisonFilter(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllComparisonFilters(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserComparisonFilterDTO>> {
            return localVarFp.getAllComparisonFilters(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProfile(options?: RawAxiosRequestConfig): AxiosPromise<LoginResponse> {
            return localVarFp.getUserProfile(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveAppCode(options?: RawAxiosRequestConfig): AxiosPromise<UserAppActivationTokenDTO> {
            return localVarFp.retrieveAppCode(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UserComparisonFilterDTO} userComparisonFilterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComparisonFilter(id: string, userComparisonFilterDTO: UserComparisonFilterDTO, options?: RawAxiosRequestConfig): AxiosPromise<UserComparisonFilterDTO> {
            return localVarFp.updateComparisonFilter(id, userComparisonFilterDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserSelfProfileUpdateDTO} userSelfProfileUpdateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserProfile(userSelfProfileUpdateDTO: UserSelfProfileUpdateDTO, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponse> {
            return localVarFp.updateUserProfile(userSelfProfileUpdateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UploadUserImageRequest} [uploadUserImageRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUserImage(uploadUserImageRequest?: UploadUserImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDTO> {
            return localVarFp.uploadUserImage(uploadUserImageRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserProfileResourceApi - object-oriented interface
 * @export
 * @class UserProfileResourceApi
 * @extends {BaseAPI}
 */
export class UserProfileResourceApi extends BaseAPI {
    /**
     * 
     * @param {UserComparisonFilterDTO} userComparisonFilterDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileResourceApi
     */
    public create(userComparisonFilterDTO: UserComparisonFilterDTO, options?: RawAxiosRequestConfig) {
        return UserProfileResourceApiFp(this.configuration).create(userComparisonFilterDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileResourceApi
     */
    public deleteComparisonFilter(id: string, options?: RawAxiosRequestConfig) {
        return UserProfileResourceApiFp(this.configuration).deleteComparisonFilter(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileResourceApi
     */
    public getAllComparisonFilters(options?: RawAxiosRequestConfig) {
        return UserProfileResourceApiFp(this.configuration).getAllComparisonFilters(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileResourceApi
     */
    public getUserProfile(options?: RawAxiosRequestConfig) {
        return UserProfileResourceApiFp(this.configuration).getUserProfile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileResourceApi
     */
    public retrieveAppCode(options?: RawAxiosRequestConfig) {
        return UserProfileResourceApiFp(this.configuration).retrieveAppCode(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UserComparisonFilterDTO} userComparisonFilterDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileResourceApi
     */
    public updateComparisonFilter(id: string, userComparisonFilterDTO: UserComparisonFilterDTO, options?: RawAxiosRequestConfig) {
        return UserProfileResourceApiFp(this.configuration).updateComparisonFilter(id, userComparisonFilterDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserSelfProfileUpdateDTO} userSelfProfileUpdateDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileResourceApi
     */
    public updateUserProfile(userSelfProfileUpdateDTO: UserSelfProfileUpdateDTO, options?: RawAxiosRequestConfig) {
        return UserProfileResourceApiFp(this.configuration).updateUserProfile(userSelfProfileUpdateDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UploadUserImageRequest} [uploadUserImageRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserProfileResourceApi
     */
    public uploadUserImage(uploadUserImageRequest?: UploadUserImageRequest, options?: RawAxiosRequestConfig) {
        return UserProfileResourceApiFp(this.configuration).uploadUserImage(uploadUserImageRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

